module.exports = __webpack_public_path__ + "static/media/biteRamps_active.25436119.svg";